import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateWebsitesBlocked = document.createElement('template');

templateWebsitesBlocked.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-1-3-ratio">

    <h2 class="display-2 widget-title">
        <span id="websitesBlockedTitle"></span>
        ${renderErrorStateIcon()}
    </h2>

    <div class="content">
        <ul id="listContainer" class="ws-list list-unstyled">
            <li class="gz-data-item">
            <div class="gz-data-item--details item-details">
                <span class="gz-data-item--title"  gz-list-element="malware"></span>
                <gz-progress class="gz-progress" gz-list-element="malwareProgressBar"></gz-progress>
                <span class="gz-data-item--value"  gz-list-element="malwareValue"></span>
            </div>
                <span class="gz-data-item--delta"  gz-list-element="malwareDelta"></span>
            </li>

            <li class="gz-data-item">
            <div class="gz-data-item--details item-details">
                <span class="gz-data-item--title"  gz-list-element="phishing"></span>
                <gz-progress class="gz-progress" gz-list-element="phishingProgressBar"></gz-progress>
                <span class="gz-data-item--value"  gz-list-element="phishingValue"></span>
            </div>
                <span class="gz-data-item--delta"  gz-list-element="phishingDelta"></span>
            </li>

            <li class="gz-data-item">
              <div class="gz-data-item--details item-details">
                <span class="gz-data-item--title"  gz-list-element="fraud"></span>
                <gz-progress class="gz-progress" gz-list-element="fraudProgressBar"></gz-progress>
                <span class="gz-data-item--value"  gz-list-element="fraudValue"></span>
              </div>
                <span class="gz-data-item--delta"  gz-list-element="fraudDelta"></span>
            </li>
        </ul>

        <gz-loader class="widget-loading" rows="5"></gz-loader>
     </div>
  </div>
`;
